// extracted by mini-css-extract-plugin
export default {"container":"BlueSkyNotEntitled_container__9welN","spacer":"BlueSkyNotEntitled_spacer__71h+8","phone":"BlueSkyNotEntitled_phone__jxKdo","link":"BlueSkyNotEntitled_link__2h6Rz"};